module.exports = __webpack_public_path__ + "static/media/icon-no-video.0c9ac8a0.svg";